import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';
import {
    faUserCog,
    faConciergeBell,
    faComments,
    faSignOutAlt,
} from '@fortawesome/pro-solid-svg-icons';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { Menu, MenuItem } from '../../components/Menu';
import { usePermission } from '../../hooks/usePermission';
import { useAlert } from '../../units/alert';
import { useSetting } from '../../units/setting';
import { useLoginState } from '../../hooks/useLoginState';
import { useLoading } from '../../units/loading';
import { usePartner } from '../../hooks/usePartner';

type MemberServiceActionPageProps = {};

MemberServiceActionPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function MemberServiceActionPage(props: MemberServiceActionPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const alert = useAlert();
    const { setting, setSetting } = useSetting();
    const { clear } = useLoginState();
    const { setIsLoading } = useLoading();
    const { permission, isLoading: isPermissionLoading } = usePermission();
    const { partner, partnerLineUid, isLoading: isPartnerLoading } = usePartner();

    useEffect(() => {
        setIsLoading(isPermissionLoading || isPartnerLoading);
    }, [permission, isPermissionLoading, isPartnerLoading]);

    return (
        <Page>
            <BackAppBar
                title="會員服務"
            />
            <PageBody maxWidth="lg">
                <Menu>
                    <MenuItem
                        icon={faUserCog}
                        text="會員專區"
                        onClick={() => history.push('/member/action')}
                    />
                    {permission?.repair_resume || permission?.product_list ? (
                        <MenuItem
                            icon={faConciergeBell}
                            text="專屬服務"
                            onClick={() => history.push('/service/action')}
                        />
                    ) : null}
                    <MenuItem
                        icon={faComments}
                        text="意見反饋"
                        onClick={() => history.push('/feedback')}
                    />
                    {(partner && !partnerLineUid) ? (
                        <MenuItem
                            icon={faSignOutAlt}
                            text="登出"
                            onClick={() => {
                                alert.show({
                                    type: 'waring',
                                    message: '確定要登出?',
                                    onConfirm: () => {
                                        clear();
                                        setSetting({
                                            ...setting,
                                            loginInfo: {
                                                ...setting.loginInfo,
                                                password: '',
                                            },
                                        });
                                        history.replace('/login?redirect=memberService/action');
                                    },
                                    cancelButton: true,
                                });
                            }}
                        />
                    ): null}
                </Menu>
            </PageBody>
        </Page>
    );
}

export { MemberServiceActionPage };
